import { languages } from 'monaco-editor/esm/vs/editor/editor.api';

const CompletionItemKind = languages.CompletionItemKind;

const falseFunc = () => false;

export function snippetsBuilder(snippets) {
    snippets || (snippets = []);

    function eq(val) {
        return function (label) {
            return val === label;
        };
    }
    function regex(val) {
        const regex = val instanceof RegExp ? val : new RegExp(val);
        return function (label) {
            return regex.test(label);
        };
    }
    function toSelector(val) {
        if(val instanceof Function) {
            return val;
        }
        if(val instanceof RegExp) {
            return regex(val);
        }
        if(val instanceof String) {
            return eq(val);
        }
        if(val instanceof Array) {
            return val.reduce((acc, val2) => {
                val2 = toSelector(val2);
                return val2 === falseFunc ? acc : (label) => acc(label) || val2(label);
            }, falseFunc);
        }
        return falseFunc;
    }
    function add(label, insertText, other) {
        const selector = label instanceof Function ? label : (label instanceof RegExp ? regex(label) : eq(label));
        const snippet = {insertText, insertTextRules: languages.CompletionItemInsertTextRule.InsertAsSnippet};
        if(other) {
            Object.assign(snippet, other);
        }
        if(!snippet.hasOwnProperty('kind')) {
            snippet.kind = languages.CompletionItemKind.Snippet;
        }
        snippets.push({
            selector, snippet
        });
    }
    return {
        add, eq, regex, toSelector, snippets
    }
}

const defaultSnippets = (function (){
const snippets = [], add = snippetsBuilder(snippets).add;
add(/^(logger|log|info)/, 'logger.info "${0:info message}"', {label: 'logger.info', documentation: 'Информационная запись в лог'})
add(/^(logger.error|error|err)/, 'logger.error "${0:error message}"', {label: 'logger.error', documentation: 'Запись в лог о ошибке'})
add(/^(if)/,
`if ($\{1:expression}) {
    $\{0}
}`, {label: 'if', documentation: 'Простое условие'})

add(/^(ife)/,
`if ($\{1:expression}) {
    $\{2}
} else {
    $\{0}
}`, {label: 'if else', documentation: 'Условие с else блоком'})

add(/^(ifn)/,
`if ($\{1:obj} == null) {
    $\{0}
}`, {label: 'if obj == null', documentation: 'Условие с проверкой на равенство null'})

add(/^(inn)/,
`if ($\{1:obj} != null) {
    $\{0}
}`, {label: 'if obj != null', documentation: 'Условие с проверкой на не равенство null'})

add(/^(iter)/,
`for (def $\{1:obj} : ($\{2:iterable} as Iterable)) {
    $\{0}
}`, {label: 'for', documentation: 'Итерация по элементам списка'})

add(/^(each)/,
`($\{1:iterable} as Iterable).each {$\{2:val} ->
    $\{0}
}`, {label: 'each', documentation: 'Итерация по элементам списка'})

add(/^(collect)/,
`($\{1:collect} as Iterable)).collect {$\{2:val} ->
    $\{2}$\{0}
}`, {label: 'collect', documentation: 'Преобразование элементов списка'})
return snippets;
})();

export default function (snippetList) {
    snippetList = [].concat(snippetList || []).concat(defaultSnippets);

    function snippets(label, startsWith) {
        const snippets = [];
        if(!label || label.length === 0) {
            return snippets;
        }
        for (const snippet of snippetList) {
            if(snippet.selector(label)) {
                snippets.push(snippet.snippet);
            } else if(startsWith && snippet.snippet.label && snippet.snippet.label.startsWith(label)) {
                snippets.push(snippet.snippet);
            }
        }
        return snippets;
    }

    function snippet(label) {
        for (const snippet of snippetList) {
            if(snippet.selector(label)) {
                return snippet.snippet;
            }
        }
        return null;
    }

    function mapSuggestion(suggestion, ignoreSnippet) {
        if(!suggestion) {
            return suggestion;
        }
        var s = ignoreSnippet ? null : snippet(suggestion.label);
        if(s) {
            Object.assign(suggestion, s);
        } else if(suggestion.kind === CompletionItemKind.Method || suggestion.kind === CompletionItemKind.Function) {
            if(!suggestion.insertText || suggestion.insertText === suggestion.label) {
                if(suggestion.label.startsWith('get')) {
                    suggestion.insertText = `${suggestion.label}()`
                } else {
                    suggestion.insertTextRules = languages.CompletionItemInsertTextRule.InsertAsSnippet;
                    suggestion.insertText = `${suggestion.label}($\{0:arguments})`
                }
            }
        }
        if(typeof suggestion.label === 'string' && typeof suggestion.detail === 'string') {
            suggestion.label = {label:suggestion.label, description: suggestion.detail};
            if(!suggestion.insertText) {
                suggestion.insertText = suggestion.label.label;
            }
        }
        return suggestion;
    }

    return Object.freeze({
        snippet,
        snippets,
        mapSuggestion
    })
}
